/* eslint-disable vue/no-useless-template-attributes */
<template>
  <main id="admin-content">
    <lti-header :collapsed="false"></lti-header>
    <div class="body-content licences-container">
      <div class="page-controls">
        <div
          class="page-controls__action-row"
          v-bind:class="{ 'd-none': search_show }"
        >
          <button
            class="page-controls__primary-action button secondary short"
            id="page-add-course-button"
            v-b-toggle.sidebar-no-header="'sidebar-new'"
          >
            <span>Crear licencia</span>
          </button>
          <EditLicenceSidebar
            :licence="new_licence"
            :ac_instances="ac_instances"
            @refresh="initLicences"
          >
          </EditLicenceSidebar>
        </div>
        <div class="page-controls__control-row">
          <div
            class="page-controls__filter"
            v-bind:class="{ 'd-none': search_show }"
          >
            <div class="dropdown-filter select-wrapper">
              <span class="filter__select-label"
                >Licencias en el intervalo
              </span>
              <form
                class="date-range ng-valid ng-valid-date ng-valid-required ng-dirty ng-valid-parse ng-valid-before-start"
              >
                <div class="picker-input date">
                  <b-form-datepicker
                    today-button
                    label-today-button="Hoy"
                    reset-button
                    label-reset-button="Limpiar"
                    label-help="Usa las flechas del teclado para navegar entre fechas"
                    label-no-date-selected="-"
                    id="start-date"
                    type="text"
                    v-model="filter_start_date"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="es"
                    @input="initLicences()"
                  >
                  </b-form-datepicker>
                </div>
                <div class="date-range__separator ng-scope">hasta</div>
                <div class="picker-input date">
                  <b-form-datepicker
                    today-button
                    label-today-button="Hoy"
                    reset-button
                    label-reset-button="Limpiar"
                    label-help="Usa las flechas del teclado para navegar entre fechas"
                    label-no-date-selected="-"
                    id="end-date"
                    type="text"
                    v-model="filter_end_date"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="es"
                    @input="initLicences()"
                  >
                  </b-form-datepicker>
                </div>
              </form>
            </div>
          </div>
          <div
            class="page-controls__search ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty"
            v-bind:class="{ 'page-controls__search--opened': search_show }"
          >
            <div class="dropdown-search">
              <button
                class="dropdown-search__toggle icon-button align-right"
                id="tooltip-target-search"
                v-bind:class="{ 'd-none': search_show }"
                @click="showSearch()"
              >
                <magnify-icon />
              </button>
              <b-tooltip target="tooltip-target-search" triggers="hover">
                Buscar licencias
              </b-tooltip>
              <div
                class="dropdown-search__dropdown"
                v-bind:class="{ 'd-none': !search_show }"
              >
                <label class="dropdown-search__icon">
                  <span>Buscar licencias</span>
                </label>
                <input
                  class="dropdown-search__input ng-pristine ng-valid ng-empty ng-touched"
                  type="text"
                  placeholder="Buscar por nombre de la licencia"
                  v-model="filter_name"
                />
                <div class="dropdown-search__controls">
                  <button
                    class="button clear short dropdown-search__control ng-scope"
                    @click="hideSearch()"
                  >
                    {{ $t("buttons.cancel") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="full-width-content--small">
        <div v-if="!licences.length" class="no-content no-results">
          <span class="no-content-title">{{ $t("licence.not-found") }}</span>
        </div>
        <table v-if="licences.length" class="content-table">
          <tbody>
            <tr class="content-table__header content-table__header--shadow">
              <th class="medium-8">Licencia</th>
              <th class="medium-4">Fecha de creación</th>
              <th class="medium-4">Clave</th>
              <th class="medium-4">Estado</th>
            </tr>
            <tr
              v-for="licence in licences"
              v-bind:key="licence.id"
              class="element-list-row"
            >
              <td class="break-word content-table__emphasis">
                <span class="inline-column-title ng-scope">Licencia:</span>
                <bdi>{{ licence.title }}</bdi>
                <EditLicenceSidebar
                  :licence="licence"
                  :ac_instances="ac_instances"
                  @refresh="initLicences"
                >
                </EditLicenceSidebar>
              </td>
              <td class="date">
                <span class="inline-column-title ng-scope">{{
                  $t("licence.createDate")
                }}</span>
                <span>{{ licence.creationDate | moment("D/M/YY HH:mm") }}</span>
              </td>
              <td class="break-word content-table__emphasis">
                <span class="inline-column-title ng-scope">Clave:</span>
                <bdi>{{ licence.key }}</bdi>
              </td>
              <td class="status-column">
                <span class="inline-column-title ng-scope">Estado:</span>
                <span v-if="licence.enabled" class="status-column__text">
                  <check-circle-outline-icon fill-color="#007d2c" :size="20" />
                  <span>{{ $t("licence.active") }}</span>
                </span>
                <span v-else class="status-column__text">
                  <close-circle-outline-icon fill-color="#7d002c" :size="20" />
                  <span>{{ $t("licence.noActive") }}</span>
                </span>
              </td>
              <td class="item-controls">
                <b-dropdown
                  right
                  menu-class="button-list-icons small-icons"
                  variant=" icon-button session-row-options list-item-icon has-tooltip"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template #button-content>
                    <dots-horizontal-circle-outline-icon :size="20" />
                    <b-tooltip
                      :target="'licence-options-' + licence.id"
                      triggers="hover"
                    >
                      {{ $t("licence.optionsLicence") }}
                    </b-tooltip>
                  </template>
                  <b-dropdown-item-btn
                    v-if="user_roles.indexOf('ROLE_ADMIN') != -1"
                    link-class="button"
                    v-b-toggle.sidebar-no-header="'sidebar-edit-' + licence.id"
                  >
                    <pencil-outline-icon
                      class="svg-icon small default"
                      :size="20"
                    />
                    <span>{{ $t("licence.editLicense") }}</span>
                  </b-dropdown-item-btn>
                  <b-dropdown-item-btn
                    v-if="user_roles.indexOf('ROLE_ADMIN') != -1"
                    link-class="button delete"
                    @click="confirmDelete(licence)"
                  >
                    <delete-outline-icon
                      fill-color="#c23e37"
                      class="svg-icon small default"
                      :size="20"
                    />
                    <span>{{ $t("licence.deleteTitle") }}</span>
                  </b-dropdown-item-btn>
                </b-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <vue-confirm-dialog class="pv-confirm"></vue-confirm-dialog>
  </main>
</template>

<script>
import LtiHeader from "@/components/Lti/Header";
import EditLicenceSidebar from "./Modals/EditLicenceSidebar";
import jwtMixin from "@/mixins/jwtMixin.js";
import utilitiesMixin from "@/mixins/utilitiesMixin";
import ServiceLicences from "@/service/licences.js";

////////////
import DotsHorizontalCircleOutlineIcon from "vue-material-design-icons/DotsHorizontalCircleOutline.vue";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
import PencilOutlineIcon from "vue-material-design-icons/PencilOutline.vue";
import CheckCircleOutlineIcon from "vue-material-design-icons/CheckCircleOutline.vue";
import CloseCircleOutlineIcon from "vue-material-design-icons/CloseCircleOutline.vue";
import DeleteOutlineIcon from "vue-material-design-icons/DeleteOutline";

export default {
  name: "LtiLicences",
  mixins: [jwtMixin, utilitiesMixin],
  components: {
    LtiHeader,
    EditLicenceSidebar,
    DotsHorizontalCircleOutlineIcon,
    MagnifyIcon,
    PencilOutlineIcon,
    CheckCircleOutlineIcon,
    CloseCircleOutlineIcon,
    DeleteOutlineIcon,
  },
  created() {
    this.initLicences();
  },
  data() {
    return {
      loading: false,
      user_groups: [],
      user_roles: null,
      licences: [],
      ac_instances: [],
      new_licence: {
        id: "",
        title: "",
        domain: "",
        enabled: true,
        key: null,
        secret: null,
        toolConsumer: 1,
        accessToken: "",
        acAutoenrol: null,
        acInstanceId: null,
        userName: "",
        password: "",
        strainingPlatformId: "",
        primaryColor: "#80C6DF",
        secondaryColor: "#69A3B8",
        font: null,
      },
      search_show: false,
      filter_start_date: null,
      filter_end_date: window.moment().endOf("day").format("YYYY-MM-DD"),
      filter_name: null,
      waiting_filter_name: false,
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    filter_name: function (val) {
      let vueComponent = this;
      if (!this.waiting_filter_name) {
        setTimeout(() => {
          vueComponent.initLicences();
          this.waiting_filter_name = false;
        }, 1500);
      }
      this.waiting_filter_name = true;
    },
  },
  methods: {
    initLicences() {
      this.loading = true;
      this.user_roles = this.jwtLoggedUserRole();
      // CMM: Se recuperan las licencias aplicando posibles filtros
      let filterParams = new URLSearchParams();
      if (this.filter_name) {
        filterParams.append("name", this.filter_name);
      }
      if (this.filter_start_date) {
        filterParams.append(
          "startDate",
          window
            .moment(this.filter_start_date)
            .startOf("day")
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        );
      }
      if (this.filter_end_date) {
        filterParams.append(
          "endDate",
          window
            .moment(this.filter_end_date)
            .endOf("day")
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        );
      }
      ServiceLicences.getLicences(filterParams)
        .then((response) => {
          this.licences = response.data;
        })
        .finally((this.loading = false));
    },

    confirmDelete(licence) {
      let auxlicence = licence;
      this.$bvModal
        .msgBoxConfirm(`${this.$t("licence.deleteQuestion")}`, {
          title: this.$t("licence.deleteTitle"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("buttons.continue"),
          cancelTitle: this.$t("buttons.noContinue"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            ServiceLicences.deletLicences(auxlicence.id).then((response) => {
              if (response && response.status === 200) {
                this.$noty.success(this.$t("licence.deleteTitle"), {
                  timeout: 3000,
                  progressBar: true,
                });
                this.initLicences();
              }
            });
          }
        })
        .catch((err) => {
          this.$noty.error(err);
        });
    },
    hideSearch() {
      this.search_show = false;
      this.filter_name = null;
      this.waiting_filter_name = false;
    },
    showSearch() {
      this.search_show = true;
    },
  },
};
</script>
